const o = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="m7.629 4.5-6.44 6.439a1.5 1.5 0 0 0 0 2.121l6.44 6.44" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="m16.371 4.5 6.44 6.439a1.5 1.5 0 0 1 0 2.121l-6.44 6.44" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
export {
  o as default
};
